export default {
    url:'https://cell-lm.rvspace.ru'
}